module.exports = __webpack_public_path__ + "img/Hulk_01.f12b6e10.png";